import {
  fetchSocialInternetData,
  setSocialInternetValues,
  switchSocialInternetPopupVisible,
} from '../actions';
import { setItemValueByType } from '../../utils/arraySetters';
import { SERVICE_TYPE } from '../../constants';

export const socialInternetReducer = {
  [setSocialInternetValues]: (state, { payload: { ...value } }) => ({
    ...state,
    extraServices: setItemValueByType(SERVICE_TYPE.socialInternet, {
      list: state.extraServices,
      value,
    }),
  }),
  [fetchSocialInternetData]: (state, { payload: socialInternetPopup }) => ({
    ...state,
    socialInternetPopup,
  }),
  [switchSocialInternetPopupVisible]: (state) => ({
    ...state,
    socialInternetPopup: {
      ...state.socialInternetPopup,
      isOpen: !state.socialInternetPopup.isOpen,
    },
  }),
};
